'use strict';
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance');
}
function _iterableToArray(r) {
    if (Symbol.iterator in Object(r) || '[object Arguments]' === Object.prototype.toString.call(r))
        return Array.from(r);
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) {
        for (var t = 0, e = new Array(r.length); t < r.length; t++)
            e[t] = r[t];
        return e;
    }
}
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.randomSort = void 0;
var randomSort = function (t, r) {
    if ('[object Array]' !== Object.prototype.toString.call(t))
        return t;
    for (var e = [], o = t.length, n = _toConsumableArray(Array(o).keys()), a = 0; a < r; a++) {
        var i = Math.ceil(Math.random() * o) - 1;
        e[a] = n[i], n.splice(i, 1), o--;
    }
    return e.sort().map(function (r) {
        return t[r];
    });
};
exports.randomSort = randomSort;